export const QUERY_BUILDER_OPERATORS: any[] = [
    { type: 'Contains', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Does Not Contain', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Matches', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Greater Than', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Greater Than Or Equal To', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Less Than', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Less Than Or Equal To', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Is Empty', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Is Not Empty', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Equals', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Does Not Equal', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Begins With', nb_inputs: 1, apply_to: ['string'] },
    { type: 'Ends With', nb_inputs: 1, apply_to: ['string'] }
];

export const VIEW_FILTER_QUERY_BUILDER_OPERATORS: any[] = [
    { type: 'Equals', nb_inputs: 1, apply_to: ['string'] }
];

export const NO_VALUE_OPERATORS = ['Is Empty', 'Is Not Empty'];


// WEBPACK FOOTER //
// ./source/ts/constants/query-builder.ts